import {OVRecommendActionEnum} from '../../../schema-types/globalTypes';
import validateUUID from '../../../utils/validateUUID';
import {
  getPotContactId,
  updateRecsVarsProps,
  upsertBuilderHeader,
} from './builderHelpers';
import {getFeeServerFromFormik} from '../CreateBuilder/BuilderDAInitialFees';

export const saveAnnuity = async (props: updateRecsVarsProps): Promise<string> => {
  const {accountId, values} = props;
  const {annuity, contact, urgency, urgencyReason} = values;

  const ovrecommendId = await upsertBuilderHeader(props, {
    action: OVRecommendActionEnum.SET_UP_NEW,
    accountId: validateUUID(accountId),
    goalId: validateUUID(values.goal?.id),
    isNewPlanRequired: true,
    contactId: getPotContactId(contact),
    urgency,
    urgencyReason,
    note: annuity?.notes,
  });

  const sourceId = annuity?.sourceId;
  if (!sourceId) {
    throw Error('Annuity requires a source pot');
  }
  const source = values.transfer?.transferSources[sourceId];

  await props.upsertBuilderAnnuity({
    variables: {
      ovrecommendId: validateUUID(ovrecommendId)!,
      potId: validateUUID(sourceId)!,
      annuityType: annuity!.annuityType!,
      isFull: source?.full ?? false,
      guaranteedPeriod: annuity!.guaranteePeriod!,
      incomeFrequency: annuity!.incomeFrequency!,
      isIndexLinked: annuity!.indexLinked!,
      initialFeeId: validateUUID(annuity?.initialFee),
      sppInitialFee: getFeeServerFromFormik(values.isSppDa, source?.legacyInitialFee),
      isLtcCapitalProtected: annuity!.longTermCareCapitalProtected!,
      notes: annuity!.notes!,
      paymentType: annuity!.paymentType!,
      protectedPercentage: annuity!.ltcProtectedPercent!,
      rateType: annuity!.rateType!,
      singleClientAmount: source?.singleClientAmount ?? undefined,
      spouseAnnuityPercent: annuity!.spouseAnnuityPercent!,
    },
  });

  return ovrecommendId;
};
